import { Grid2 as Grid, Box, Skeleton, Stack, Container } from '@common/components'
import { CenterContainer } from '@common/containers'

const ForgetPlaceholder = () => {
  return (
    <Container maxWidth='lg'>
      <Grid container sx={{ height: '100vh', alignItems: 'center' }}>
        <Grid size={{ xs: 12, md: 6 }} sx={{ display: { xs: 'none', md: 'flex' } }}>
          <Box sx={{ height: '300px', width: '100%', maxWidth: { xs: '200px', md: '350px' } }}>
            <Skeleton variant='rounded' width='100%' height='100%' />
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Skeleton width={300} height={60} sx={{ maxWidth: '90%  ' }} />
            <Skeleton width={400} height={100} sx={{ maxWidth: '90%' }} />
            <Skeleton width={400} height={100} sx={{ maxWidth: '90%' }} />
            <Skeleton variant='text' width={200} sx={{ maxWidth: '90%' }} />
            <Skeleton width={350} height={60} sx={{ maxWidth: '90%' }} />
            <Skeleton variant='text' width={50} sx={{ maxWidth: '90%' }} />
            <Skeleton width={350} height={60} sx={{ maxWidth: '90%' }} />
          </Box>
        </Grid>
      </Grid>
    </Container>
  )
}

export default ForgetPlaceholder
